// extracted by mini-css-extract-plugin
export var dropdownButton = "_23-0";
export var fullWidthDropdownButton = "_23-1";
export var icon = "_23-3";
export var iconPlaceholder = "_23-2";
export var menuItemRow = "_23-9";
export var separator = "_23-e";
export var shortcutContainer = "_23-7";
export var shortcutContainerFilled = "_23-8";
export var shortcutIconLg = "_23-6";
export var shortcutIconMd = "_23-5";
export var shortcutIconSm = "_23-4";
export var submenuChevron = "_23-d";
export var submenuDropdown = "_23-a";
export var submenuTriggerRow = "_23-b";
export var submenuTriggerRowOpen = "_23-c";